import React, { useState, useEffect } from 'react';
import HeroFrameMachine from '../components/HeroFrameMachine';
import StickerModal from '../components/StickerModal';
import databaseService from '../services/databaseService';
import backgroundImageService from '../services/backgroundImageService';
import { getColorByIndex } from '../data/colors';
import logger from '../utils/logger.js';
import './HeroFrameMachineTestPage.css';

const HeroFrameMachineTestPage = () => {
  const [allStickers, setAllStickers] = useState([]);
  const [isLoadingStickers, setIsLoadingStickers] = useState(true);
  const [useSmartLoading, setUseSmartLoading] = useState(true);
  const [backgroundImage, setBackgroundImage] = useState('');
  
  // Modal state
  const [selectedListing, setSelectedListing] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Set random background image on component mount
  useEffect(() => {
    const randomBackground = backgroundImageService.getRandomBackground();
    setBackgroundImage(randomBackground);
  }, []);

  // Load stickers data
  useEffect(() => {
    const loadStickers = async () => {
      try {
        setIsLoadingStickers(true);
        
        // Load stickers for the new hero scene
        const response = await databaseService.getUnifiedStickers({
          size: 'MICRO',
          hasSvgPath: true,
          limit: 100
        });
        
        // Extract the data array from the response
        const stickers = response.data || [];
        setAllStickers(stickers);
        setIsLoadingStickers(false);
      } catch (error) {
        console.error('Failed to load stickers for new hero test:', error);
        setIsLoadingStickers(false);
      }
    };

    loadStickers();
  }, []);

  // Handle sticker click - open modal
  const handleStickerClick = async (data) => {
    logger.log('Sticker clicked:', data);
    
    // Get the listing ID
    const listingId = data.listingId || data.id;
    
    try {
      // Fetch the full listing data
      const unifiedData = await databaseService.getUnifiedStickerData(listingId);
      logger.log('🔍 Debug - unifiedData:', unifiedData);
      logger.log('🔍 Debug - listingId:', listingId);
      
      if (unifiedData && unifiedData.data) {
        const listing = unifiedData.data;
        
        // Convert color index to color name for the modal
        let clickedColor = 'Black (Matte)'; // Default fallback
        if (data.colorIndex !== undefined && data.colorIndex !== null) {
          const colorData = getColorByIndex(data.colorIndex);
          if (colorData) {
            clickedColor = colorData.name;
          }
        }
        
        // Add the clicked size and color to the listing data for the modal - same as homepage
        const listingWithSizeAndColor = {
          ...listing,
          clickedSize: data.size,
          clickedColor: clickedColor
        };
        
        setSelectedListing(listingWithSizeAndColor);
        setIsModalOpen(true);
      } else {
        logger.warn('⚠️ API returned null/empty data for listing:', listingId);
      }
    } catch (error) {
      console.error('Error fetching listing data:', error);
    }
  };
  
  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedListing(null);
  };

  // Handle add to scene (placeholder for now)
  const handleAddToScene = (stickerData) => {
    // TODO: Implement add to scene functionality
  };

  return (
    <div 
      className="hero-frame-machine-test-page"
      style={{
        position: 'relative'
      }}
    >
      {/* Blurred background layer */}
      <div 
        className="background-layer"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(2px) brightness(0.7)',
          zIndex: -2
        }}
      ></div>
      
      {/* Overlay to further darken background */}
      <div 
        className="background-overlay"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          zIndex: -1
        }}
      ></div>
      
      {/* Content wrapper to bring content above overlay */}
      <div 
        style={{
          position: 'relative',
          zIndex: 10,
          height: '100%'
        }}
      >
      {/* Header */}
      <div className="test-page-header">
        <div className="test-page-nav">
          <button 
            className="nav-button"
            onClick={() => window.location.href = '/'}
          >
            ← Back to Home
          </button>
          <h1>Hero Frame Machine Test</h1>
          <div className="test-controls">
            <label>
              <input
                type="checkbox"
                checked={useSmartLoading}
                onChange={(e) => setUseSmartLoading(e.target.checked)}
              />
              Use Smart Loading
            </label>
          </div>
        </div>
      </div>

      {/* Hero Frame Machine */}
      <div className="test-page-content">
        <HeroFrameMachine
          onStickerClick={handleStickerClick}
          allStickers={allStickers}
          isLoadingStickers={isLoadingStickers}
          useSmartLoading={useSmartLoading}
          excludedListingIds={[1327319473, 855766109]}
        />
      </div>
      
      </div> {/* End content wrapper */}
      
      {/* Modal for sticker details */}
      <StickerModal
        isOpen={isModalOpen}
        selectedListing={selectedListing}
        onClose={handleModalClose}
        onAddToScene={handleAddToScene}
      />
    </div>
  );
};

export default HeroFrameMachineTestPage;
